import { Component, Input } from '@angular/core';
import { ColorUtils } from "../../ui-utils/color-utils";
var HTML_TEMPLATE = "\n<div  class=\"od-badge\">\n\t<div class=\"od-badge-inner\" [textContent]=\"_text\"\n\t [ngStyle]=\"{'background-color':_color,'color':_fontColor,'font-size': _size,'min-width': _size,'height':_size}\">\n\t</div>\n</div>\n";
var CSS_STYLE = "\n.od-badge{\n\tdisplay: block;\n}\n\n.od-badge,\n.od-badge-inner{\n\tborder-radius:100px;\n}\n.od-badge-inner{\n\tjustify-content: center;\n\talign-items: center;\n\tdisplay: flex;\n    font-weight: bolder;\n    padding: 3px;\n    box-sizing: content-box;\n}\n";
var Badge = /** @class */ (function () {
    function Badge() {
        this.size = 16;
        this.color = "#000000";
        this.text = "";
    }
    Object.defineProperty(Badge.prototype, "size", {
        set: function (value) {
            if (value != null)
                this._size = value + "px";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Badge.prototype, "color", {
        set: function (value) {
            if (value != null) {
                this._color = value;
                this._fontColor = ColorUtils.getTints(value);
            }
            else {
                this._color = "transparent";
                this._fontColor = "#000000";
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Badge.prototype, "text", {
        set: function (value) {
            if (value != null)
                this._text = value;
        },
        enumerable: true,
        configurable: true
    });
    Badge.decorators = [
        { type: Component, args: [{
                    selector: 'od-badge',
                    template: HTML_TEMPLATE,
                    styles: [CSS_STYLE]
                },] },
    ];
    /** @nocollapse */
    Badge.ctorParameters = function () { return []; };
    Badge.propDecorators = {
        "size": [{ type: Input },],
        "color": [{ type: Input },],
        "text": [{ type: Input },],
    };
    return Badge;
}());
export { Badge };
//# sourceMappingURL=badge.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui-components/badge/badge.js
// module id = 411
// module chunks = 14